
import { useEffect, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";

// import { useUser } from "../../../hooks/useUser";
import icon from "../../../assets/static/images/secciones/bandejaentrada.png";

import Inicio from "./Inicio";
import Juicios from "./Juicios";
import Convenios from "../Convenios/Convenios";
import PlanesDePago from "../PlanesDePago/PlanesDePago";
import { useUser } from "../../../hooks/useUser";
import { AbogadoModal } from "../../../components/AbogadoModal";
import ArrowBack from "../../../components/ArrowBack";
import { useSelector } from "react-redux";
import "./index.css";

const MesaEntradasJudicial = () => {
  const { abogadoJudicial } = useSelector((e) => e.mesasEntrada);

  const [key, setKey] = useState("juicios");
  const [show, setShow] = useState(false);
  const [abogado, setAbogado] = useState("");
  const [dataList, setDataList] = useState([]);
  const [tab, setTab] = useState("ACTIVOS");

  const user = useUser();

  useEffect(() => {
    if (abogadoJudicial) {
      setAbogado(abogadoJudicial);
    }
    else if (user.abogado === "A00") {
      setShow(true);
    } else {
      setAbogado(user.abogado);
    }
  }, []);

  const handleKey = (e) => {
    setKey(e);
  };

  const handleClose = () => setShow(false);

  return (
    <div className="section-content inbox-section mesa-judicial">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="bandejaentrada" />
        <span>Mesa de entradas judicial</span>
      </div>
      <ArrowBack />

      {abogado && !show && (
        <Tabs
          activeKey={key}
          onSelect={handleKey}
          className="w-full mt-5"
        >
          { user.rol !== "guest"
            ? <Tab eventKey="inicio" title="Inicio">
              {key === "inicio" && <Inicio abogado={abogado} />}
            </Tab>
            : null
          }
          <Tab eventKey="juicios" title="Juicios">
            {key === "juicios" && <Juicios abogado={abogado} setTab={setTab} tab={tab} setDataList={setDataList} dataList={dataList} />}
          </Tab>
          <Tab eventKey="convenios" title="Convenios">
            {key === "convenios" && <Convenios />}
          </Tab>
          <Tab eventKey="planesdepago" title="Planes de Pago">
            {key === "planesdepago" && <PlanesDePago />}
          </Tab>
        </Tabs>
      )}

      {show && <AbogadoModal show={show} handleClose={handleClose} setAbogado={setAbogado} abogado={abogado} />}
    </div>
  );
};


export default MesaEntradasJudicial;